import PropTypes from 'prop-types';

import ImmutablePropTypes from 'react-immutable-proptypes';
import ImmutablePureComponent from 'react-immutable-pure-component';
import { connect } from 'react-redux';

import { getAverageFromBlurhash } from 'mastodon/blurhash';
import { IconButton } from 'mastodon/components/icon_button';
import Footer from 'mastodon/features/picture_in_picture/components/footer';
import Video from 'mastodon/features/video';

import Status_container from 'mastodon/containers/status_container';
import { CloseIcon } from 'mastodon/components/icons/close';
import classNames from 'classnames';

const mapStateToProps = (state, { statusId }) => ({
  status: state.getIn(['statuses', statusId]),
});

class VideoModal extends ImmutablePureComponent {

  static propTypes = {
    media: ImmutablePropTypes.map.isRequired,
    statusId: PropTypes.string,
    status: ImmutablePropTypes.map,
    options: PropTypes.shape({
      startTime: PropTypes.number,
      autoPlay: PropTypes.bool,
      defaultVolume: PropTypes.number,
    }),
    onClose: PropTypes.func.isRequired,
    onChangeBackgroundColor: PropTypes.func.isRequired,
    onNavigateAway: PropTypes.func,
  };

  state = {
    navigationHidden: false,
  };

  componentDidMount () {
    window.addEventListener('resize', this.handleResize, false);
    document.body.classList.add('with-modals--active');

    this.setState({
      navigationHidden: window.innerWidth <= 768,
    });
    const { media, onChangeBackgroundColor } = this.props;

    const backgroundColor = getAverageFromBlurhash(media.get('blurhash'));

    if (backgroundColor) {
      onChangeBackgroundColor(backgroundColor);
    }

    const controls = document.querySelector('.video-player__controls');
    if (controls) {
      controls.classList.add('active');
    }
  }

  componentWillUnmount () {
    window.removeEventListener('resize', this.handleResize);
    document.body.classList.remove('with-modals--active');
    this.props.onChangeBackgroundColor(null);

    const controls = document.querySelector('.video-player__controls');
    if (controls) {
      controls.classList.add('active');
    }
  }

  handleResize = () => {
    this.setState({
      navigationHidden: window.innerWidth <= 768,
    });
  };

  handleToggleNavigation = () => {
    if (window.innerWidth <= 768) {
      this.setState(prevState => ({
        navigationHidden: !prevState.navigationHidden,
      }));
    }
  };

  handleStatusClick = (e) => {
    e.stopPropagation();
  };

  handleEmbeddedNavigation = (e) => {
    if (e.target.closest('a[href]')) {
      this.props.onNavigateAway?.();
    }
  };

  render () {
    const { media, status, onClose, navigationHidden } = this.props;
    const options = this.props.options || {};
    const language = status.getIn(['translation', 'language']) || status.get('language');
    const description = media.getIn(['translation', 'description']) || media.get('description');

    const statusModalClassName = classNames('status_video_modal', {
      hidden: navigationHidden,
    });

    const navigationClassName = classNames('media-modal__navigation', {
      'media-modal__navigation--hidden': navigationHidden,
    });
    return (
      <div className='modal-root__modal video-modal' onClick={this.handleToggleNavigation}>
        <div className='video-modal__container'>
          <Video
            preview={media.get('preview_url')}
            frameRate={media.getIn(['meta', 'original', 'frame_rate'])}
            aspectRatio={`${media.getIn(['meta', 'original', 'width'])} / ${media.getIn(['meta', 'original', 'height'])}`}
            blurhash={media.get('blurhash')}
            src={media.get('url')}
            currentTime={options.startTime}
            autoPlay={options.autoPlay}
            volume={options.defaultVolume}
            onCloseVideo={onClose}
            autoFocus
            detailed
            alt={description}
            lang={language}
          />
          <div
            className={statusModalClassName}
            onClickCapture={this.handleEmbeddedNavigation}
            onClick={this.handleStatusClick}
          >
            <Status_container
              key={status.get('id')}
              id={status.get('id')}
              showThread
              isVideoModal
            />
          </div>
        </div>

        <div className={navigationClassName}>
          <div className='media-modal__buttons'>
            <IconButton
              title='Close'
              icon='times'
              iconComponent={CloseIcon}
              onClick={onClose}
            />
          </div>

          <div className='media-modal__overlay'>
            {status && <Footer statusId={status.get('id')} withOpenButton onClose={onClose} />}
          </div>
        </div>
      </div>
    );
  }

}

export default connect(mapStateToProps, null, null, { forwardRef: true })(VideoModal);
